export const ALL_VALUE = 'All'

/** Matches `.ant-select-dropdown-menu-item` min-height in HKLSelect.vue */
export const DROPDOWN_OPTION_HEIGHT_PX = 34

/** `.ant-select-dropdown-menu` top or bottom padding in ant-design-vue. */
export const DROPDOWN_MENU_EDGE_PADDING_PX = 4

/** `.ant-select-dropdown-menu` vertical padding (4px top + 4px bottom in ant-design-vue). */
export const DROPDOWN_MENU_VERTICAL_PADDING_PX = DROPDOWN_MENU_EDGE_PADDING_PX * 2

/** Max option rows visible before the native dropdown scrolls. */
export const MAX_VISIBLE_DROPDOWN_OPTIONS = 6

export const dropdownViewportMaxHeightPx = (
  maxVisibleOptions = MAX_VISIBLE_DROPDOWN_OPTIONS,
  optionHeightPx = DROPDOWN_OPTION_HEIGHT_PX,
  menuVerticalPaddingPx = DROPDOWN_MENU_VERTICAL_PADDING_PX,
) => {
  return maxVisibleOptions * optionHeightPx + menuVerticalPaddingPx
}

export const scrollDropdownViewportMaxHeightPx = (
  maxVisibleOptions = MAX_VISIBLE_DROPDOWN_OPTIONS,
  optionHeightPx = DROPDOWN_OPTION_HEIGHT_PX,
) => {
  return dropdownViewportMaxHeightPx(maxVisibleOptions, optionHeightPx, DROPDOWN_MENU_EDGE_PADDING_PX)
}
